import React from "react";
import ContainerBody from "../components/ContainerBody";
import ContainerNav from "../components/ContainerNav";
import { Slider, Switch, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import ButtonLink from "../components/ButtonLink";
import ContainerRoot from "../components/ContainerRoot";

export default function Parameters(props) {
  const handleInputChange = (key, value) => {
    props.setParameters({ ...props.parameters, [key]: value });
  };

  const handleToggleSwitch = () => {
    props.setParameters({
      ...props.parameters,
      guessMode: !props.parameters.guessMode,
    });
  };

  return (
    <ContainerRoot>
      <ContainerBody>
        <Typography>Parameters(skip it the first time)</Typography>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <Typography>Guess Mode</Typography>
            <Switch
              checked={props.parameters.guessMode}
              onChange={handleToggleSwitch}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography>Seed</Typography>
            <TextField
              placeholder="0"
              defaultValue={props.parameters.seed}
              disabled
              size="small"
              fullWidth
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography>DDIM Steps</Typography>
            <Slider
              aria-label="Temperature"
              value={props.parameters.ddimSteps}
              valueLabelDisplay="on"
              onChange={(event, value) => handleInputChange("ddimSteps", value)}
              min={1}
              max={30}
              step={1}
              marks={[
                {
                  value: 1,
                  label: "1",
                },
                {
                  value: 30,
                  label: "30",
                },
              ]}
              size="small"
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography>Scale</Typography>
            <Slider
              aria-label="Temperature"
              value={props.parameters.scale}
              valueLabelDisplay="on"
              onChange={(event, value) => handleInputChange("scale", value)}
              min={0.1}
              max={30}
              step={0.1}
              marks={[
                {
                  value: 0.1,
                  label: "0.1",
                },
                {
                  value: 30,
                  label: "30",
                },
              ]}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>Strength(Have no idea what is it)</Typography>
            <Slider
              aria-label="Temperature"
              valueLabelDisplay="on"
              value={props.parameters.strength}
              size="small"
              onChange={(event, value) => handleInputChange("strength", value)}
              min={0}
              max={1}
              marks={[
                {
                  value: 0,
                  label: "0",
                },
                {
                  value: 1,
                  label: "1",
                },
              ]}
              step={0.1}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography>Image Resolution</Typography>
            <Slider
              aria-label="Temperature"
              value={props.parameters.imageResolution}
              size="small"
              onChange={(event, value) =>
                handleInputChange("imageResolution", value)
              }
              min={256}
              max={768}
              step={256}
              marks={[
                {
                  value: 256,
                  label: "256",
                },
                {
                  value: 512,
                  label: "512",
                },
                {
                  value: 768,
                  label: "768",
                },
              ]}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Typography>Detect Resolution</Typography>
            <Slider
              aria-label="Temperature"
              value={props.parameters.detectResolution}
              size="small"
              onChange={(event, value) =>
                handleInputChange("detectResolution", value)
              }
              marks={[
                {
                  value: 256,
                  label: "256",
                },
                {
                  value: 512,
                  label: "512",
                },
                {
                  value: 768,
                  label: "768",
                },
                {
                  value: 1024,
                  label: "1024",
                },
              ]}
              min={256}
              max={1024}
              step={256}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>Value Threshold</Typography>
            <Slider
              aria-label="Temperature"
              valueLabelDisplay="on"
              size="small"
              value={props.parameters.valueThreshold}
              onChange={(event, value) =>
                handleInputChange("valueThreshold", value)
              }
              min={0.01}
              max={2}
              step={0.01}
              marks={[
                {
                  value: 0.01,
                  label: "0.01",
                },
                {
                  value: 2,
                  label: "2",
                },
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>Distance Threshold</Typography>
            <Slider
              size="small"
              valueLabelDisplay="on"
              value={props.parameters.distanceThreshold}
              onChange={(event, value) =>
                handleInputChange("distanceThreshold", value)
              }
              min={0.01}
              max={20}
              step={0.01}
              marks={[
                {
                  value: 0.01,
                  label: "0.01",
                },
                {
                  value: 20,
                  label: "20",
                },
              ]}
            />
          </Grid>
        </Grid>
      </ContainerBody>
      <ContainerNav>
        <ButtonLink url="/image" title="Back" />
        {/* <ButtonLink
          url="/hardprompts"
          title="Add hard Prompts"
          color="primary"
        /> */}
        <ButtonLink url="/prompt" title="Add Prompt" color="primary" />
      </ContainerNav>
    </ContainerRoot>
  );
}
